import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { FocusedCard } from '@brokerbay/design-components';
import { useParams, useHistory } from 'react-router';

import { Steps } from '../../types';
import { ClaimPrefix, CommonStep, OrgOnboardingStep } from '../../constants';
import { buildNavigationHandler, NavigationProps } from '../../util';
import { OrgOnboardingSelectContextProvider } from '../../contexts/OrgOnboardingSelectContext';
import { GetStartedView } from './epic-1/GetStartedView';
import { FindBrokerageView } from './epic-1/FindBrokerageView';
import ContactSalesView from './epic-1/ContactSalesView';

export const OnboardingOrgSelectView = () => {
  const { hash } = useParams<{ hash: string }>();

  const history = useHistory();
  const pathPrefix = ClaimPrefix.ORG_SELECT;
  const defaultUrlParams = [{ name: 'hash', value: hash }];

  const navigationHandler = (
    nextStep: Steps,
    opts?: Partial<NavigationProps>,
  ) =>
    buildNavigationHandler({
      history,
      prefix: ClaimPrefix.ORG_SELECT,
      urlParams: defaultUrlParams,
      nextStep,
      ...opts,
    });

  return (
    <OrgOnboardingSelectContextProvider onboardingPortalHash={hash}>
      <FocusedCard>
        <Switch>
          <Route
            exact
            path={`${pathPrefix}/${CommonStep.GET_STARTED}`}
            render={props => (
              <GetStartedView
                handleGoNextStep={navigationHandler(
                  OrgOnboardingStep.FIND_BROKERAGE,
                )}
                {...props}
              />
            )}
          />

          <Route
            exact
            path={`${pathPrefix}/${OrgOnboardingStep.FIND_BROKERAGE}`}
            render={props => (
              <FindBrokerageView
                handleGoBackStep={navigationHandler(CommonStep.GET_STARTED)}
                handleGoNextStep={(claimHash: string) =>
                  navigationHandler(OrgOnboardingStep.PRIMARY_ROLE, {
                    prefix: ClaimPrefix.ORG_PROFILE,
                    urlParams: [{ name: 'hash', value: claimHash }],
                  })
                }
                handleGoContactStep={navigationHandler(
                  OrgOnboardingStep.CONTACT_SALES,
                )}
                {...props}
              />
            )}
          />

          <Route
            exact
            path={`${pathPrefix}/${OrgOnboardingStep.CONTACT_SALES}`}
            render={props => (
              <ContactSalesView
                handleGoBackStep={navigationHandler(
                  OrgOnboardingStep.FIND_BROKERAGE,
                )}
                {...props}
              />
            )}
          />
        </Switch>
      </FocusedCard>
    </OrgOnboardingSelectContextProvider>
  );
};
